export default __webpack_public_path__ + "static/media/distribution.f528d94d.png";